import { FC } from 'react';

import {
  AssessmentQuestionType,
  AssessmentSignatureUserInput,
  AutofillSource,
  ContactType,
} from '../../../../generated/graphql';

export type Question = {
  questionType: AssessmentQuestionType;
  isRequired: boolean;
  question: string;
  answerOptions: string[];
  assessmentUserOrderIndices: number[];
  allowedExtensions?: string[];
  autofillSource?: AutofillSource;
  defaultToToday?: boolean;
  contactType?: ContactType;
};

export type QuestionForm = {
  name: string;
  description: string;
  questions: Question[];
  assessmentSignatureUsers?: AssessmentSignatureUserInput[];
  completableByProviderOnly?: boolean;
};

export const QuestionTypeValueHash = {
  [AssessmentQuestionType.MultipleChoice]: 'Multiple choice',
  [AssessmentQuestionType.MultiSelect]: 'Multiple select',
  [AssessmentQuestionType.FreeText]: 'Short text',
  [AssessmentQuestionType.RichText]: 'Long text',
  [AssessmentQuestionType.Initials]: 'Client initials',
  [AssessmentQuestionType.Signature]: 'Client signature',
  [AssessmentQuestionType.MultiSignature]: 'Collaborative signature',
  [AssessmentQuestionType.ProviderSignature]: 'Provider signature',
  [AssessmentQuestionType.Statement]: 'Statement (read-only)',
  [AssessmentQuestionType.FileUpload]: 'File upload',
  [AssessmentQuestionType.Autofill]: 'Autofill',
  [AssessmentQuestionType.DatePicker]: 'Date Picker',
  [AssessmentQuestionType.PatientContact]: 'Client Contact',
};

export const SUPPORTED_QUESTION_TYPE_OPTIONS = Object.keys(
  QuestionTypeValueHash,
);

export const QuestionTypeItem: FC<{
  value:
    | AssessmentQuestionType.FreeText
    | AssessmentQuestionType.MultipleChoice
    | AssessmentQuestionType.MultiSelect
    | AssessmentQuestionType.RichText
    | AssessmentQuestionType.Initials
    | AssessmentQuestionType.Signature
    | AssessmentQuestionType.MultiSignature
    | AssessmentQuestionType.ProviderSignature
    | AssessmentQuestionType.Statement
    | AssessmentQuestionType.FileUpload
    | AssessmentQuestionType.Autofill
    | AssessmentQuestionType.DatePicker
    | AssessmentQuestionType.PatientContact;
}> = ({ value }) => (
  <span className="text-caption">{QuestionTypeValueHash[value]}</span>
);
